import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { tap, map, switchMap, of, take, combineLatest } from 'rxjs';
import { AuthService } from './auth.service';

export const authGuard: (mustBeLogged: boolean) => CanActivateFn =
  (mustBeLogged: boolean) => (route) => {
    const router = inject(Router);
    const auth = inject(AuthService);
    return combineLatest([auth.logged$, auth._profile$]).pipe(
      map(([logged, profile]) => {
        // This page in reachable only if not authenticated
        if (!mustBeLogged) {
          if (logged) {
            router.navigate(['']);
            return false;
          } else return true;
        }
        // This page in reachable only if authenticated
        else {
          if (!logged) {
            router.navigate(['login']);
            return false;
          } else {
            if (profile?.displayName && profile?.tosAcceptedAt && profile?.tosVersion === auth.TOS_VERSION) {
              return true;
            } else {
              if (route.url.at(0)?.path === 'create-displayname') return true;
              else {
                router.navigate(['create-displayname']);
                return false;
              }
            }
          }
        }
      })
    );
  };
